import React from 'react'

export const LabelValueDisplayerSCN = (props: {
  label: string
  hide?: boolean
  children: React.ReactNode
}) => {
  if (props.hide) return null

  return (
    <div className='flex w-full items-start justify-between'>
      <span className='text-sm font-medium'>{props.label}</span>
      <div className='flex w-2/3 justify-end text-right text-sm'>
        {props.children || 'Dato no disponible'}
      </div>
    </div>
  )
}
